export const WEBSITE_POSTHOG_OPTIONS = {
  api_host: "https://us.i.posthog.com",
  loaded: (posthog) => posthog.register({ app_surface: "website" }),
  before_send: (event) => ({ ...event, properties: { ...event.properties, app_surface: "website" } }),
};
